import React, { useRef, useState, useEffect } from "react";
import "./Products.css";

// components imports
import ProductTable from "../../../Components/BoltTable/BoltTable";
import BulkActionBar, {
  BulkActionButton,
} from "../../../Components/BoltTable/Components/BulkActionBar";
import ImagesModal from "../Components/ImagesModal/ImagesModal";
import ProductQuantityModal from "../Components/ProductQuantityModal/ProductQuantityModal";
import ProductDimensionModal from "../Components/ProductDimensionModal/ProductDimensionModal";
import ProductIdentifierModal from "../Components/ProductIdentifierModal/ProductIdentifierModal";
import ProductDetailsModal from "../Components/ProductDetailsModal/ProductDetailsModal";
import DescriptionModal from "../Components/DescriptionModal/DescriptionModal";
import ImportModal from "../Components/ImportModal/Import";
import ProductHistoryModal from "../Components/HistoryModal/HistoryModal";
import PackagesDimensionsModal from "../Components/PackagesDimensions/PackagesDimensionsModal";
import ProductWeightModal from "../Components/ProductWeightModal/ProductWeightModal";
import Tooltip from "../../../Components/Tooltip/Tooltip";
import Confirm from "../../../Components/Popups/Confirm";

// apis imports
import {
  fetchAllProducts,
  deleteProduct,
} from "../../../services/product.service";
import { fetchWarehouseProductReporting } from "../../../services/warehouse.services";
import { generateExcelFile } from "./productExport";
import { handleBulkForcasting } from "./productForecasting";
// library imports

import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { BsWordpress } from "react-icons/bs";
import { FaEbay } from "react-icons/fa";
import { FaShopify } from "react-icons/fa";
import {
  AiOutlineAmazon,
  AiOutlineImport,
  AiOutlineBarcode,
} from "react-icons/ai";
import { MdOutlineEditCalendar } from "react-icons/md";
import { FcPlus } from "react-icons/fc";
import {
  MdEditCalendar,
  MdHistory,
  MdOutlineCancel,
  MdOutlineAutoGraph,
} from "react-icons/md";
import { TbBrandWalmart } from "react-icons/tb";
import { PiExportLight, PiPackageLight } from "react-icons/pi";
import noImage from "../../../assets/images/noImage.png";
import LabelModal from "../Components/LabelModal/LabelModal";
import { Dimensions, Weight } from "./ProductService";

import { Menu, MenuItem, IconButton } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import BoltButton from "../../../Components/UI/Buttons/BoltButton";
import { useTranslation } from "react-i18next";

const marketplaceIcons = {
  bestbuy: <BsWordpress size={20} />,
  eBay: <FaEbay size={20} />,
  Woocommerce: <BsWordpress size={20} />,
  shopify: <FaShopify size={20} />,
  amazon: <AiOutlineAmazon size={20} />,
  walmart: <TbBrandWalmart size={20} />,
};

const SOLD_QUANTITY_THEMES = {
  success:
    "bg-state-success-bg text-state-success-text border-state-success-border",
  warning:
    "bg-state-warning-bg text-state-warning-text border-state-warning-border",
  danger:
    "bg-state-danger-bg text-state-danger-text border-state-danger-border",
};

const SoldQuantityBadge = ({
  soldQty,
  days,
  totalAvailable,
  className = "",
}) => {
  const { t } = useTranslation("inventory");
  let theme = "danger";
  if (totalAvailable > 0) {
    const percentage = (soldQty / totalAvailable) * 100;
    theme =
      percentage <= 50 ? "success" : percentage <= 100 ? "warning" : "danger";
  }

  return (
    <span
      className={`inline-flex items-center gap-1 rounded border px-1.5 py-[1px] text-[11px] leading-4 font-semibold ${SOLD_QUANTITY_THEMES[theme]} ${className}`}
    >
      {soldQty}
      <span className="text-[10px] font-normal opacity-80">
        {t("products.perDays", { count: Number(days) })}
      </span>
    </span>
  );
};

const ShipperProduct = ({ snack, setSnack }) => {
  const { t } = useTranslation(["inventory", "common"]);
  const [Products, setProducts] = useState([]);
  const [Brands, setBrands] = useState([]);
  const [Suppliers, setSuppliers] = useState([]);
  const [MarketPlaces, setMarketPlaces] = useState([]);
  const [Import, setImport] = useState(false);
  const [showVariants, setShowVariants] = useState(false);
  const [imagesModal, setImagesModal] = useState();
  const [descriptionModal, setDescriptionModal] = useState();
  const [prodDetailsModal, setProdDetailsModal] = useState(false);
  const [prodHistoryModal, setProdHistoryModal] = useState(false);
  const [labelModal, setLabelModal] = useState(false);
  const [prodIdentifierModal, setProdIdentifierModal] = useState(false);
  const [prodDimensionModal, setProdDimensionModal] = useState(false);
  const [packagesDimensionModal, setPackagesDimensionModal] = useState(false);
  const [productWeightModal, setProductWeightModal] = useState(false);
  const [prodQuantityModal, setProdQuantityModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteLoader, setdeleteLoader] = useState(false);
  const [forcastingLoader, setForcastingLoader] = useState(false);

  const user = useSelector((state) => state.user);
  const navigate = useNavigate();

  const defaultWidth = "200px";

  const ImageUrl = (row) => {
    const url =
      row?.media.find((media) => media.is_primary === "true")?.file ||
      row?.media[0]?.file;
    return url || noImage;
  };

  const [soldQuantityFilter, setsoldQuantityFilter] = useState([]);
  const [loadingForecastRowIds, setLoadingForecastRowIds] = useState([]);

  const SoldQuantityLabel = ({ rowId, name }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const selectedValue =
      soldQuantityFilter?.find((item) => item?.rowId === rowId)?.value ?? 30;

    const handleDropDown = (value) => {
      setsoldQuantityFilter((prev) => {
        const existingIndex = prev.findIndex((item) => item?.rowId === rowId);
        const updated = [...prev];

        if (existingIndex !== -1) {
          updated[existingIndex].value = value;
        } else {
          updated.push({ value, rowId });
        }

        return updated;
      });
      handleClose();
    };

    return (
      <>
        <span>{name}</span>
        <IconButton
          size="small"
          onClick={handleClick}
          className="flex flex-col items-center justify-center leading-none p-0"
        >
          <span className="text-xxs leading-none">({selectedValue})</span>
          <ArrowDropDownIcon fontSize="small" />
        </IconButton>
        <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
          {[30, 90, 180].map((option) => (
            <MenuItem
              key={option}
              selected={selectedValue === option}
              onClick={() => handleDropDown(option)}
            >
              {t("products.lastDays", { count: option })}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  };

  const columns = [
    // {
    //   id: 0,
    //   label: "#",
    //   render: (row) => <>{row?.id ?? "-"}</>,
    //   width: defaultWidth,
    // },
    {
      id: 1,
      label: t("products.image"),
      render: (row) => (
        <img
          src={ImageUrl(row)}
          onClick={() => setImagesModal(row?.id)}
          onError={(e) => {
            e.target.src = noImage;
          }}
          loading="lazy"
        />
      ),
      // fixed: "left",
    },
    {
      id: 2,
      label: t("products.productTitle"),
      render: (row) => <>{row.name ?? "-"}</>,
      fixed: "left",
      width: defaultWidth,
    },
    {
      id: 3,
      label: t("products.productId"),
      render: (row) => <>{row.code ?? "-"}</>,
      width: defaultWidth,
    },
    {
      id: 4,
      label: t("products.sku"),
      // render: (row, rowIndex, handleFieldChange) => (
      //   <div
      //     className="product_identifier_parent_wrapper"
      //     onClick={() =>
      //       setProdIdentifierModal({ row, rowIndex, handleFieldChange })
      //     }
      //   >
      //     <div className="product_identifier_wrapper">
      //       {row?.product_skus.map((sku, index) => {
      //         return (
      //           <span onClick={(e) => e.stopPropagation()}>
      //             {" "}
      //             <a
      //               href={sku?.slug}
      //               target="_blank"
      //               className="marketplace_icon"
      //               key={index}
      //             >
      //               <span>{marketplaceIcons[sku?.market_place?.market]}</span>
      //             </a>
      //           </span>
      //         );
      //       })}
      //     </div>
      //   </div>
      // ),
      // render: (row, rowIndex, handleFieldChange) => (
      //   <>
      //     {row?.product_skus?.length > 0 ? (
      //       <>
      //         <div className="table_action__wrap">
      //           <Tooltip title="View Marketplaces Sku's">
      //             <div
      //               className="table_action__btn"
      //               onClick={() =>
      //                 setProdIdentifierModal({
      //                   row,
      //                   rowIndex,
      //                   handleFieldChange,
      //                 })
      //               }
      //             >
      //               <MdEditCalendar size={10} />
      //               Marketplaces
      //             </div>
      //           </Tooltip>
      //         </div>
      //       </>
      //     ) : null}
      //   </>
      // ),
      render: (row) => (
        <>
          {row?.children?.length == 0 ? <>{row?.product_sku ?? "-"}</> : null}
        </>
      ),
      width: defaultWidth,
    },
    {
      id: 6,
      label: t("products.salePrice"),
      render: (row) => (
        <>
          {row?.children?.length == 0 ? <>{row.sale_price ?? "-"}</> : <>-</>}
        </>
      ),
      width: defaultWidth,
    },
    {
      id: 7,
      label: t("products.totalValue"),
      render: (row) => (
        <>
          {(
            row?.product_warehouse?.reduce(
              (total, warehouse) =>
                total + (parseInt(warehouse?.quantity, 10) || 0),
              0,
            ) * (parseFloat(row?.sale_price) || 0)
          ).toFixed(1)}
        </>
      ),
      width: defaultWidth,
    },
    {
      id: 8,
      label: t("products.productBrand"),
      render: (row) => <>{row?.brand?.name || "-"}</>,
      width: defaultWidth,
    },
    {
      id: 9,
      label: t("products.dimensionsLWH"),
      render: (row, rowIndex, handleFieldChange) => (
        <>
          {row?.children?.length == 0 ? (
            <>
              <div
                onClick={() =>
                  setProdDimensionModal({ row, rowIndex, handleFieldChange })
                }
                style={{ cursor: "pointer" }}
              >
                <Dimensions
                  length={row?.length ?? 0}
                  width={row?.width ?? 0}
                  height={row?.height ?? 0}
                  unit={
                    row?.dimension_unit?.toLowerCase() === "in" ? "inch" : "cm"
                  }
                  space={true}
                />
              </div>
            </>
          ) : null}
        </>
      ),
      width: defaultWidth,
    },
    {
      id: 10,
      label: t("products.packages"),
      render: (row) => (
        <>
          {row?.children?.length == 0 ? (
            <>
              <div
                className="product_dimension_parent_wrapper"
                style={{ maxWidth: "200px" }}
              >
                <div
                  className="product__notification_circle_wrapper"
                  onClick={() => setPackagesDimensionModal(row)}
                >
                  <PiPackageLight size={10} />
                  {row?.package_details &&
                    Object?.values(row?.package_details)?.length > 0 && (
                      <div className="product__notification_circle">
                        {Object.values(row?.package_details)?.length}
                      </div>
                    )}
                </div>
              </div>
            </>
          ) : null}
        </>
      ),
      width: defaultWidth,
    },
    {
      id: 11,
      label: t("products.weight"),
      render: (row) => (
        <>
          {row?.children?.length == 0 ? (
            <div
              style={{ cursor: "pointer" }}
              onClick={() => setProductWeightModal(row)}
            >
              <Weight
                weight={row?.weight ?? 0}
                unit={row?.weight_unit?.toLowerCase() === "lb" ? "lb" : "kg"}
                space={true}
              />
            </div>
          ) : null}
        </>
      ),
      width: defaultWidth,
    },
    {
      id: 12,
      label: <SoldQuantityLabel rowId={12} name="Quantity" />,
      render: (row, rowIndex, handleFieldChange) => {
        if (row?.children?.length > 0) return null;

        const totals = row?.product_warehouse?.reduce(
          (acc, warehouse) => {
            acc.total += Number(warehouse?.quantity ?? 0);
            acc.totalStock += Number(warehouse?.grn_details_sum_quantity ?? 0);
            acc.receivedStock += Number(
              warehouse?.grn_details_sum_received_quantity ?? 0,
            );

            const forecast = warehouse?.productforcasting;
            if (forecast) {
              acc.forecast.lastThirtyDays += Number(
                forecast?.lastThirtyDays?.totalSellQuantity ?? 0,
              );
              acc.forecast.lastNintyDays += Number(
                forecast?.lastNintyDays?.totalSellQuantity ?? 0,
              );
              acc.forecast.lastOneEightyDays += Number(
                forecast?.lastOneEightyDays?.totalSellQuantity ?? 0,
              );
              acc.forecasting = true;
            }

            return acc;
          },
          {
            total: 0,
            totalStock: 0,
            receivedStock: 0,
            forecast: {
              lastThirtyDays: 0,
              lastNintyDays: 0,
              lastOneEightyDays: 0,
            },
            forecasting: false,
          },
        );

        const expStock = totals.totalStock - totals.receivedStock;
        const soldItem = soldQuantityFilter?.find((item) => item?.rowId === 12);
        const selectedDays = soldItem?.value || 30; // fallback to 30
        const soldQty = {
          30: totals.forecast.lastThirtyDays,
          90: totals.forecast.lastNintyDays,
          180: totals.forecast.lastOneEightyDays,
        }[selectedDays];

        const totalAvailable = totals.total;

        return (
          <>
            <div
              onClick={() =>
                setProdQuantityModal({ row, rowIndex, handleFieldChange })
              }
              className="flex cursor-pointer flex-col items-center rounded text-center hover:bg-[#a79f9f14]"
            >
              <div>
                <span
                  className={totalAvailable < 0 ? "text-state-danger-text" : ""}
                >
                  {totalAvailable}
                </span>

                {expStock !== 0 && (
                  <span className="text-state-success-text">
                    +{expStock}{t("products.exp")}
                  </span>
                )}
              </div>

              {totals.forecasting && (
                <SoldQuantityBadge
                  soldQty={soldQty}
                  days={selectedDays}
                  totalAvailable={totalAvailable}
                  className="mt-1"
                />
              )}
            </div>
          </>
        );
      },
      width: defaultWidth,
    },
    {
      id: 13,
      label: t("products.action"),
      field_name: "action",
      render: (row, rowIndex, handleFieldChange) => (
        <>
          <div className="table_action__wrap">
            <Tooltip title={t("products.viewProductDetails")}>
              <div
                className="table_action__btn"
                onClick={() =>
                  setProdDetailsModal({ row, rowIndex, handleFieldChange })
                }
              >
                <MdEditCalendar size={10} />
                {t("common:actions.view")}
              </div>
            </Tooltip>
            <Tooltip title={t("products.editProduct")}>
              <div
                className="table_action__btn"
                onClick={() => navigate("/edit-product", { state: row })}
              >
                <MdOutlineEditCalendar size={10} />
                {t("common:actions.edit")}
              </div>
            </Tooltip>
            <Tooltip title={t("products.viewProductHistory")}>
              <div
                className="table_action__btn"
                onClick={() =>
                  setProdHistoryModal({ row, rowIndex, handleFieldChange })
                }
              >
                <MdHistory size={10} />
                {t("products.history")}
              </div>
            </Tooltip>
            <Tooltip title={t("products.downloadProductBarcodes")}>
              <div
                className="table_action__btn"
                onClick={() =>
                  setLabelModal({ row, rowIndex, handleFieldChange })
                }
              >
                <AiOutlineBarcode size={10} />
                {t("products.barcode")}
              </div>
            </Tooltip>
            <Tooltip title={t("products.deleteProduct")}>
              <div
                className="table_action__btn"
                onClick={() => setConfirmDelete(row)}
              >
                <MdOutlineCancel size={10} />
                {t("common:actions.delete")}
              </div>
            </Tooltip>
          </div>
        </>
      ),
      width: defaultWidth,
      fixed: "right",
    },
  ];

  const getAllProducts = async (page, perPage, filter) => {
    const response = await fetchAllProducts(page, perPage, filter);
    if (!response.error) {
      setProducts(response?.data?.result?.products);
      setBrands(response?.data?.result?.brands);
      setSuppliers(response?.data?.result?.user_suppliers);
      setMarketPlaces(response?.data?.result?.user_market_places);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const handleDeleteRequest = async (data) => {
    if (data.id) {
      setdeleteLoader(true);
      const response = await deleteProduct(data.id);

      if (!response.error && response?.data?.success) {
        setProducts((prevProducts) => {
          return {
            ...prevProducts,
            data: prevProducts?.data?.filter((d) => d?.id != data?.id),
          };
        });
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("products.productDeletedSuccessfully"),
            severity: "success",
          };
        });
        setdeleteLoader(false);
        setConfirmDelete(false);
      } else {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("products.couldntCancelThisRequest"),
            severity: "error",
          };
        });
        setdeleteLoader(false);
      }
    }
  };

  const warehouses = user?.user_approved_warehouses;
  const insertIndex = columns.length - 1;

  warehouses?.forEach((warehouse, index) => {
    const columnIndex = 1000 + index;

    const getMatchedWarehouse = (row) =>
      row?.product_warehouse?.find(
        (item) => item?.warehouse_id == warehouse?.warehouse_id,
      );

    columns.splice(insertIndex, 0, {
      id: columnIndex,
      label: (
        <SoldQuantityLabel
          rowId={columnIndex}
          name={warehouse?.warehouse?.name}
        />
      ),
      width: "300px",
      render: (row, rowIndex, handleFieldChange) => {
        const matchedWarehouse = getMatchedWarehouse(row);
        if (!matchedWarehouse || row?.children?.length > 0) return null;

        const totalStock = Number(
          matchedWarehouse?.grn_details_sum_quantity ?? 0,
        );
        const receivedStock = Number(
          matchedWarehouse?.grn_details_sum_received_quantity ?? 0,
        );
        const expStock = totalStock - receivedStock;
        const total = Number(matchedWarehouse?.quantity ?? 0) + expStock;

        const forecast = matchedWarehouse?.productforcasting;
        const isLoading = loadingForecastRowIds.includes(matchedWarehouse?.id);

        const soldItem = soldQuantityFilter?.find(
          (item) => item?.rowId === columnIndex,
        );
        const value = soldItem?.value ?? 30;

        const quantities = {
          30: forecast?.lastThirtyDays?.totalSellQuantity,
          90: forecast?.lastNintyDays?.totalSellQuantity,
          180: forecast?.lastOneEightyDays?.totalSellQuantity,
        };
        const soldQty = quantities[value] ?? quantities[30];

        const openModal = () =>
          setProdQuantityModal({
            row: {
              ...row,
              product_warehouse: row?.product_warehouse?.filter(
                (w) => w?.warehouse_id === warehouse?.warehouse_id,
              ),
            },
            rowIndex,
            handleFieldChange,
          });

        const handleForecastClick = () =>
          !isLoading && handleForcasting(matchedWarehouse, row);

        return (
          <div className="flex flex-col items-center justify-center gap-1.5">
            {/* Quantity Section */}
            <div
              onClick={openModal}
              className="cursor-pointer rounded hover:bg-[#a79f9f14]"
            >
              <span
                className={
                  matchedWarehouse?.quantity < 0 ? "text-state-danger-text" : ""
                }
              >
                {matchedWarehouse?.quantity}
              </span>

              {expStock !== 0 && (
                <span className="text-state-success-text">
                  +{expStock}{t("products.exp")}
                </span>
              )}
            </div>

            {/* Forecast Section */}
            {!forecast ? (
              <div
                onClick={handleForecastClick}
                className={
                  isLoading
                    ? "cursor-wait text-ui-text-muted"
                    : "cursor-pointer text-brand underline"
                }
              >
                {isLoading ? (
                  <div className="h-[18px] w-16 animate-pulse rounded bg-ui-border" />
                ) : (
                  t("products.clickToView")
                )}
              </div>
            ) : (
              <SoldQuantityBadge
                soldQty={soldQty}
                days={value}
                totalAvailable={total}
              />
            )}
          </div>
        );
      },
    });
  });

  const handleForcasting = async (warehouse, row) => {
    setLoadingForecastRowIds((prev) => [...prev, warehouse?.id]);

    const response = await fetchWarehouseProductReporting(warehouse?.id);

    if (response.error) {
      setSnack((snack) => ({
        ...snack,
        open: true,
        text: t("common:messages.somethingWentWrong"),
        severity: "error",
      }));
      setLoadingForecastRowIds((prev) =>
        prev.filter((id) => id !== warehouse?.id),
      );
      return;
    }

    setProducts((prevProducts) => {
      const updatedData = prevProducts?.data?.map((product) => {
        const isParent = !row?.parent_id && product?.id === row?.id;
        const isChild =
          row?.parent_id && product?.id === parseInt(row?.parent_id);

        if (isParent) {
          return {
            ...product,
            product_warehouse: updateWarehouses(product?.product_warehouse),
          };
        }

        if (isChild) {
          return {
            ...product,
            children: product?.children?.map((child) => {
              if (child?.id === parseInt(row?.id)) {
                return {
                  ...child,
                  product_warehouse: updateWarehouses(child?.product_warehouse),
                };
              }
              return child;
            }),
          };
        }

        return product;
      });

      return { ...prevProducts, data: updatedData };
    });

    function updateWarehouses(warehouses) {
      return warehouses?.map((item) =>
        item?.id === warehouse?.id
          ? { ...item, productforcasting: response?.data?.result }
          : item,
      );
    }

    setLoadingForecastRowIds((prev) =>
      prev.filter((id) => id !== warehouse?.id),
    );
  };

  return (
    <>
      <ProductQuantityModal
        open={prodQuantityModal}
        setOpen={setProdQuantityModal}
        setProdHistoryModal={setProdHistoryModal}
        setProducts={setProducts}
        setSnack={setSnack}
      />
      <LabelModal
        open={labelModal}
        setOpen={setLabelModal}
        setSnack={setSnack}
        labelData={{
          code: labelModal?.row?.code,
          name: labelModal?.row?.name,
          image: labelModal?.row?.media?.find((image) => image?.is_primary)
            ?.file,
        }}
        title={t("products.productsBarcode")}
        subtitle={`${labelModal?.row?.full_name ?? ""} (${
          labelModal?.row?.code ?? ""
        })`}
      />
      <ProductDimensionModal
        open={prodDimensionModal}
        setOpen={setProdDimensionModal}
        Products={Products}
        setProducts={setProducts}
        setSnack={setSnack}
      />
      <PackagesDimensionsModal
        open={packagesDimensionModal}
        setOpen={setPackagesDimensionModal}
        Products={Products}
        setProducts={setProducts}
        setSnack={setSnack}
      />
      <ProductWeightModal
        open={productWeightModal}
        setOpen={setProductWeightModal}
        Products={Products}
        setProducts={setProducts}
        setSnack={setSnack}
      />
      <ImportModal
        open={Import}
        setOpen={setImport}
        setSnack={setSnack}
        getAllProducts={getAllProducts}
      />
      <ProductIdentifierModal
        open={prodIdentifierModal}
        setOpen={setProdIdentifierModal}
        setSnack={setSnack}
        setProducts={setProducts}
      />
      <ProductDetailsModal
        open={prodDetailsModal}
        setOpen={setProdDetailsModal}
        setSnack={setSnack}
      />
      <ProductHistoryModal
        open={prodHistoryModal}
        setOpen={setProdHistoryModal}
      />
      <DescriptionModal
        open={descriptionModal}
        setOpen={setDescriptionModal}
        setSnack={setSnack}
      />
      <ImagesModal
        open={imagesModal}
        setOpen={setImagesModal}
        setSnack={setSnack}
        setProducts={setProducts}
      />
      <Confirm
        open={confirmDelete}
        setOpen={setConfirmDelete}
        handleConfirm={() => handleDeleteRequest(confirmDelete)}
        text={t("products.doYouWantToDeleteThisProduct")}
        loader={deleteLoader}
      />
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <ProductTable
          tableTitle={t("products.products")}
          tableId="ShipperProductTable"
          message={t("products.noProductsAvailableToDisplay")}
          searchPlaceHolder={t("products.searchProducts")}
          columns={columns}
          data={Products}
          showVariants={showVariants}
          getAllData={getAllProducts}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          selectable={true}
          headerButtons={
            <div className="flex gap-1 flex-wrap">
              <BoltButton
                icon={AiOutlineImport}
                label={t("products.importData")}
                onClick={() => setImport(true)}
                variant="primary"
                size="sm"
              />
              {Products?.data?.length > 0 && (
                <BoltButton
                  label={t("products.showVariants")}
                  onClick={() => setShowVariants(!showVariants)}
                  variant="outline"
                  size="sm"
                  render={() => (
                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        id="show_variant_toggle"
                        onClick={() => setShowVariants(!showVariants)}
                        checked={showVariants}
                      />
                      <span>{t("products.showVariants")}</span>
                    </div>
                  )}
                />
              )}
              <BoltButton
                icon={FcPlus}
                label={t("products.addProduct")}
                onClick={() =>
                  navigate(
                    user.role === "Shipper"
                      ? "/AddProduct"
                      : "/warehouse-AddNewProduct",
                  )
                }
                variant="success"
                size="sm"
              />
            </div>
          }
        />
        <BulkActionBar
          count={selectedRows.length}
          onClear={() => setSelectedRows([])}
        >
          <BulkActionButton
            label={t("products.exportSelected")}
            onClick={() =>
              generateExcelFile(
                Products?.data,
                selectedRows,
                showVariants,
                setSnack,
                Suppliers,
                user.user_approved_warehouses,
                MarketPlaces,
              )
            }
            icon={PiExportLight}
          />
          <BulkActionButton
            label={t("products.viewSalesForecast")}
            onClick={() =>
              handleBulkForcasting(
                Products,
                selectedRows,
                setForcastingLoader,
                setProducts,
                setSnack,
              )
            }
            disabled={forcastingLoader}
            icon={
              forcastingLoader
                ? () => (
                    <div className="w-3 h-3 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  )
                : MdOutlineAutoGraph
            }
          />
        </BulkActionBar>
      </div>
    </>
  );
};

export default ShipperProduct;
